"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cardMedia = exports.cardMediaBase = void 0;

var _stylitas = require("@creditas/stylitas");

const cardMediaBase = () => (0, _stylitas.css)`
  display: block;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;

exports.cardMediaBase = cardMediaBase;

const cardMedia = ({
  isMedia
}) => isMedia && (0, _stylitas.css)`
    width: 100%;
    object-fit: cover;
  `;

exports.cardMedia = cardMedia;